import styled from 'styled-components';
import PropTypes from 'prop-types';
import Dropdown from '@comp/Dropdown/Dropdown';
import TextField from '@base/TextField/TextField';
import { getEmailError, getNameError } from '@utils/formHelper';
import { Spacings } from '@styles/index';

const StyledTextField = styled(TextField)`
  margin-top: ${Spacings.SPACING_4B};
  color: ${({ theme }) => theme.colors.fontGreyV2};
`;

const DropdownWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  grid-column-gap: ${Spacings.SPACING_4B};
  margin-top: ${Spacings.SPACING_4B};
  ${({ theme }) => `${theme.breakpoints.down('mobile')} {
      grid-template-columns: repeat(10, 1fr);
      grid-column-gap: 0px;
    };`}
`;

const EnterOtherFields = ({
  fieldsData,
  setFieldsData,
  otpOrEmailResponse,
  states,
  country,
  error,
  isTTU
}) => {
  const onFieldChange = (type) => (e) => {
    const data = {
      ...fieldsData,
      [type]: {
        ...fieldsData[type],
        value: e.target.value
      }
    };
    setFieldsData(data);
  };

  const onStateOptionChange = (stateOption) => {
    const data = {
      ...fieldsData,
      state: {
        ...fieldsData.state,
        value: stateOption.value
      }
    };
    setFieldsData(data);
  };

  const stateOptionsArr = states.map((stateData) => ({
    label: stateData?.name,
    value: stateData?.code
  }));

  const stateOptions = [
    { label: 'Select - State of residence', value: '' },
    ...stateOptionsArr
  ];

  const { isEmailError, emailErrorMsg } = getEmailError(error);
  const { isNameError, nameErrorMsg } = getNameError(error);

  if (!otpOrEmailResponse) return <></>;
  return (
    <>
      {!otpOrEmailResponse.has_name && !isTTU ? (
        <StyledTextField
          fullWidth
          value={fieldsData.name.value}
          type="text"
          placeholder="Name"
          onChange={onFieldChange(fieldsData.name.type)}
          error={isNameError}
          helperText={nameErrorMsg}
        />
      ) : null}
      {!otpOrEmailResponse.has_email ? (
        <StyledTextField
          fullWidth
          value={fieldsData.email.value}
          type="text"
          placeholder="Email address"
          onChange={onFieldChange(fieldsData.email.type)}
          error={isEmailError}
          helperText={emailErrorMsg}
        />
      ) : null}
      {country?.code === 'IN' && !otpOrEmailResponse.has_state ? (
        <DropdownWrapper>
          <Dropdown
            gridColumn="span 10"
            options={stateOptions}
            onOptionClick={onStateOptionChange}
            selectedOption={stateOptions.find(
              (stateData) => stateData.value === fieldsData.state.value
            )}
            menuWidth="464px"
          />
        </DropdownWrapper>
      ) : null}
    </>
  );
};

export default EnterOtherFields;

EnterOtherFields.propTypes = {
  fieldsData: PropTypes.objectOf(PropTypes.any).isRequired,
  setFieldsData: PropTypes.func.isRequired,
  otpOrEmailResponse: PropTypes.objectOf(PropTypes.any),
  states: PropTypes.arrayOf(PropTypes.any).isRequired,
  country: PropTypes.objectOf(PropTypes.any).isRequired,
  error: PropTypes.objectOf(PropTypes.any),
  isTTU: PropTypes.bool
};

EnterOtherFields.defaultProps = {
  otpOrEmailResponse: null,
  error: {},
  isTTU: false
};
